module.exports = __webpack_public_path__ + "static/media/party-catering-2.234c151e.jpg";